module.exports = __webpack_public_path__ + "assets/img/digido-logo-350.34ab0c43.png";